import React from 'react'
import {Form} from 'antd'
/**
 * @typedef {{[key: string]: Function}} MixObject
 * @typedef {{id?: string, key?: string, formProps: FormItemProps, decoProps: GetFieldDecoratorOptions, [key: string]: any}} FormItemParams
 */

/**
 * @description mixin装饰器，可以混合class，或Plain-Object
 * @param {MixObject} toBeMixed
 * @return {Generator}
 */
function mixin (toBeMixed) {
  /**
   * @generator
   */
  return function (_target, name, descriptor) {
    let target = _target
    if (toBeMixed.prototype) {
      if (!toBeMixed.prototype.init) console.error(`用于mixin的类: ${toBeMixed.name}，必须要有init方法`)
      Object.getOwnPropertyNames(toBeMixed.prototype).forEach(key => {
        if (key !== 'constructor') {
          // if (key === 'init') {
          //   const fn = target.prototype[key]
          //   target.prototype[key] = function (...args) {
          //     if (fn) {
          //       fn.call(this, ...args)
          //       toBeMixed.prototype[key].call(this, ...args)
          //     } else {
          //       toBeMixed.prototype[key].call(this, ...args)
          //     }
          //   }
          // } else if (key === 'componentWillMount' || key === 'componentDidMount' || key === 'componentDidUpdate' || key==='componentWillUnmount') {
            const fn = target.prototype[key]
            target.prototype[key] = function (...args) {
              if (fn) {
                const r = fn.call(this, ...args)
                if (r && r.then && typeof r.then === 'function') {
                  return r.then(() => {
                    toBeMixed.prototype[key].call(this, ...args)
                  })
                } else {
                  return toBeMixed.prototype[key].call(this, ...args)
                }
              } else {
                return toBeMixed.prototype[key].call(this, ...args)
              }
            }
          // } else {
          //   target.prototype[key] = toBeMixed.prototype[key]
          // }
        }
      })
    }
    else
      Object.assign(target.prototype, toBeMixed)
    return target
  }
}

/**
 * @description 将指定函数绑定到form.item的装饰器
 * @param {FormItemParams} formItemParams 入参
 */
function formItem ({id = null, key = null, formProps = {}, decoProps = {}} = {}) {
    const {getFieldDecorator} = this.props.form
    /**
     * @param {ReactComponent[]} elements
     * @param {ReactComponent[]} extraElements
     */
    return function decorate (elements, extraElements) {
      return <React.Fragment key={key || id}><Form.Item  {...formProps}>
          {
            getFieldDecorator(id, {
              ...decoProps
            })(Array.isArray(elements) ? elements[0] : elements)
          }
          {Array.isArray(elements) && elements.filter((_, idx) => idx !== 0)}
        </Form.Item>{extraElements}</React.Fragment>
  }
}
// function withFormItem ({id = null, key = null, formProps = {}, decoProps = {}} = {}) {
//   return function (target, name, descriptor) {
//     const originFn = descriptor.value
//     descriptor.value = function newFn (...args) {
//       const _id = args[0] && args[0].id || id
//       const _key = args[0] &&  args[0].key || key
//       if (!_id) throw new Error ('缺少id')
//       const _formProps = Object.assign({}, formProps, (args[0] && args[0].formProps) || {})
//       const _decoProps = Object.assign({}, decoProps, (args[0] && args[0].decoProps) || {})
//       const {getFieldDecorator} = this.props.form
//       const elements = originFn.call(this, ...args)
//       return <Form.Item key={_key} {..._formProps}>
//         {
//           getFieldDecorator(_id, {
//             ..._decoProps
//           })(Array.isArray(elements) ? elements[0] : elements)
//         }
//         {Array.isArray(elements) && elements.filter((_, idx) => idx !== 0)}
//       </Form.Item>
//     }
//   }
// }
// /**
//  * @description 把若干参数转换为约定的格式，方便withFormItem包裹之后的表单项使用
//  * @param {ConvertFn} convertFn
//  * @return {(target: Function, name: string, descriptor: {value: Function, [key: string]: any}) => void}
//  */
// function convertData (convertFn) {
//   return function (target, name, descriptor) {
//     const fn = descriptor.value
//     descriptor.value = function (...args) {
//       const convertedData = convertFn(...args)
//       return fn.call(this, convertedData)
//     }
//   }
// }
// /**
//  * @description 返回数组形式的参数，被装饰的函数得到的值是多个
//  * @param {ConvertFnMutiple} convertFn
//  * @return {(target: Function, name: string, descriptor: {value: Function, [key: string]: any}) => void}
//  */
// function convertDataMutilple (convertFn) {
//   return function (target, name, descriptor) {
//     const fn = descriptor.value
//     descriptor.value = function (...args) {
//       const convertedData = convertFn(...args)
//       if (!Array.isArray(convertedData)) throw Error('convertDataMutilple要求返回数组')
//       return fn.apply(this, convertedData)
//     }
//   }
// }
export {
  mixin,
  formItem
}